import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export default function NotFoundPage() {
    return (
        <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="60vh" textAlign="center" py={8}>
            <ErrorOutlineIcon sx={{ fontSize: 80, color: 'text.disabled', mb: 2 }} />
            <Typography variant="h1" fontWeight={700} sx={{ fontSize: '5rem' }}>404</Typography>
            <Typography variant="h6" color="text.secondary" gutterBottom>Page not found</Typography>
            <Button component={Link} to="/" variant="contained" sx={{ mt: 2 }}>
                Go Home
            </Button>
        </Box>
    );
}
